var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGridIconBlack = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66675 1.97436H13.3334V1.30769H4.66675V1.97436Z",
    fill: "#333539"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66675 6.64103H13.3334V5.97437H4.66675V6.64103Z",
    fill: "#333539"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66675 11.3077H13.3334V10.641H4.66675V11.3077Z",
    fill: "#333539"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33333 0.641029C0.597867 0.641029 0 1.2389 0 1.97436C0 2.71143 0.597867 3.3077 1.33333 3.3077C2.0688 3.3077 2.66667 2.71143 2.66667 1.97436C2.66667 1.2389 2.0688 0.641029 1.33333 0.641029ZM1.33333 1.0677C1.83333 1.0677 2.24 1.47436 2.24 1.97436C2.24 2.47436 1.83333 2.88103 1.33333 2.88103C0.833333 2.88103 0.426667 2.47436 0.426667 1.97436C0.426667 1.47436 0.833333 1.0677 1.33333 1.0677Z",
    fill: "#333539"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33333 5.30769C0.597867 5.30769 0 5.90556 0 6.64103C0 7.37809 0.597867 7.97436 1.33333 7.97436C2.0688 7.97436 2.66667 7.37809 2.66667 6.64103C2.66667 5.90556 2.0688 5.30769 1.33333 5.30769ZM1.33333 5.73436C1.83333 5.73436 2.24 6.14103 2.24 6.64103C2.24 7.14103 1.83333 7.54769 1.33333 7.54769C0.833333 7.54769 0.426667 7.14103 0.426667 6.64103C0.426667 6.14103 0.833333 5.73436 1.33333 5.73436Z",
    fill: "#333539"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33333 9.30769C0.597867 9.30769 0 9.90556 0 10.641C0 11.3781 0.597867 11.9744 1.33333 11.9744C2.0688 11.9744 2.66667 11.3781 2.66667 10.641C2.66667 9.90556 2.0688 9.30769 1.33333 9.30769ZM1.33333 9.73436C1.83333 9.73436 2.24 10.141 2.24 10.641C2.24 11.141 1.83333 11.5477 1.33333 11.5477C0.833333 11.5477 0.426667 11.141 0.426667 10.641C0.426667 10.141 0.833333 9.73436 1.33333 9.73436Z",
    fill: "#333539"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGridIconBlack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/gridIconBlack.3f9a99c7.svg";
export { ForwardRef as ReactComponent };